module.exports = __webpack_public_path__ + "img/card-list.676c2654.svg";